export const GET_PERMISSION_TEMPLATE_BY_SERVICE_TYPES_QUERY = `
  query GetPermissionTemplateByServiceTypes($serviceTypes: [String!]!, $controlTowerId: String!) {
    getPermissionTemplateByServiceTypes(serviceTypes: $serviceTypes, controlTowerId: $controlTowerId) {
      _id
      nodeId
      name
      permissionLevels {
        admin
        editor
        viewer
        adminDisabled
        editorDisabled
        viewerDisabled
      }
      parentId
      expanded
      level
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

export const GET_PERMISSION_TREE_QUERY = `
  query GetPermissionTree($collaboratorId: String!, $controlTowerId: String!) {
    getPermissionTree(collaboratorId: $collaboratorId, controlTowerId: $controlTowerId) {
      _id
      nodeId
      name
      permissionLevels {
        admin
        editor
        viewer
        adminDisabled
        editorDisabled
        viewerDisabled
      }
      parentId
      expanded
      level
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

export const SAVE_COLLABORATOR_PERMISSION_TREE_MUTATION = `
  mutation SaveCollaboratorPermissionTree($input: SaveCollaboratorPermissionTreeInput!) {
    saveCollaboratorPermissionTree(input: $input)
  }
`;

export const GET_USER_PERMISSION_PRESET_QUERY = `
  query GetUserPermissionPreset($inviteeIdentifier: String!, $controlTowerId: String!) {
    getUserPermissionPreset(inviteeIdentifier: $inviteeIdentifier, controlTowerId: $controlTowerId) {
      _id
      nodeId
      name
      permissionLevels {
        admin
        editor
        viewer
        adminDisabled
        editorDisabled
        viewerDisabled
      }
      parentId
      expanded
      level
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

export const SAVE_USER_PERMISSION_PRESET_MUTATION = `
  mutation SaveUserPermissionPreset($input: SaveUserPermissionPresetInput!) {
    saveUserPermissionPreset(input: $input) {
      _id
      inviterOrgId
      inviteeIdentifier
      inviteeType
      isActive
      createdAt
      updatedAt
    }
  }
`;
